import { Form, Input, Modal, Select } from 'antd';
import { ForeignCustomers } from '../../lib/ForeignCustomer';
import { API } from '../../api';
interface Props {
  open?: boolean;
  onClose: () => void;
  onSuccess: () => void;
}
export const CustomsPackageImport = ({ open, onClose, onSuccess }: Props) => {
  const [form] = Form.useForm();
  const onSubmit = async (data: any) => {
    try {
      const result = await API.get({ apiVersion: 'api' })(
        `/foreign/sync/package/${data.packageNumber}`
      );
    } catch (e) {
      console.log(e);
    }
    onSuccess();
  };
  return (
    <Modal
      title="package import"
      open={open}
      onClose={onClose}
      onCancel={onClose}
      onOk={() => form.submit()}
    >
      <Form layout="vertical" form={form} onFinish={onSubmit}>
        <Form.Item name={'customer'} label="Харилцагч" required>
          {/* <Select style={{ width: 250 }} placeholder="Харилцагч" allowClear>
            {Object.keys(ForeignCustomers).map((key) => {
              const typedKey = key as keyof typeof ForeignCustomers;
              return <Select.Option value={key}>{ForeignCustomers[typedKey]}</Select.Option>
            })}
          </Select> */}
        </Form.Item>
        <Form.Item name={'packageNumber'} required label="packageNumber">
          <Input />
        </Form.Item>
      </Form>
    </Modal>
  );
};
